import { createSlice } from "@reduxjs/toolkit";
import { createApiThunk, updateState } from "./utilityFunction"

// Initial State
const initialState = {
    saveSubProject: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
    fetchSubProject: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
    enblSubProject: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
};

export const fetchSubProject = createApiThunk("subProject", "fetch")
export const saveSubProject = createApiThunk("subProject", "save")
export const enblSubProject = createApiThunk("enblSubProject", "save")
// Slice
const subProjectSlice = createSlice({
    name: "subProject",
    initialState,
    reducers: {
        resetSubProState: (state, action) => {
            const type = action.payload; // Assuming the type is passed in the action's payload

            if (type === "fetch") {
                state.fetchSubProject = {
                    ...state.fetchSubProject, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            } else if (type === "save") {
                state.saveSubProject = {
                    ...state.saveSubProject, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            }
            else if (type === "enbl") {
                state.enblSubProject = {
                    ...state.enblSubProject,
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                }
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(enblSubProject.pending, (state) => updateState(state, "pending", "enblSubProject",))
            .addCase(enblSubProject.fulfilled, (state, action) => updateState(state, "fulfilled", "enblSubProject", action.payload.data))
            .addCase(enblSubProject.rejected, (state, action) => updateState(state, "rejected", "enblSubProject", action.payload))
            // Fetch projects
            .addCase(saveSubProject.pending, (state) => updateState(state, "pending", "saveSubProject",))
            .addCase(saveSubProject.fulfilled, (state, action) => updateState(state, "fulfilled", "saveSubProject", action.payload.data))
            .addCase(saveSubProject.rejected, (state, action) => updateState(state, "rejected", "saveSubProject", action.payload))
            // Fetch projects
            .addCase(fetchSubProject.pending, (state) => updateState(state, "pending", "fetchSubProject"))
            .addCase(fetchSubProject.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "fetchSubProject", action.payload.data))
            .addCase(fetchSubProject.rejected, (state, action) =>
                updateState(state, "rejected", "fetchSubProject", action.payload));
    },
});

export const { resetSubProState } = subProjectSlice.actions;
export default subProjectSlice.reducer;
